export const LINE_CHART_CONFIG: Highcharts.Options = {
  title: {
    text: "",
    align: "left",
  },
  chart: {
    type: "spline",
  },
  yAxis: {
    title: {
      text: "",
    },
    accessibility: {
      rangeDescription: "Range:  22 Jan to 13 Feb",
    },
  },
  tooltip: {
    shared: false,
    split: true,
  },
  credits: {
    enabled: false,
  },
  legend: {
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom",
  },
  plotOptions: {
    series: {
      label: {
        connectorAllowed: false,
      },
      pointStart: 0,
    },
  },
  series: [],
  exporting: {
    enabled: true,
    fallbackToExportServer: true,
    sourceWidth: 1400,
    sourceHeight: 600,
    scale: 2,
    chartOptions: {
      chart: {
        marginRight: 30,
      },
      xAxis: {
        labels: {
          step: 1,
          rotation: -45,
        },
      },
    },
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          legend: {
            layout: "horizontal",
            align: "center",
            verticalAlign: "bottom",
          },
        },
      },
    ],
  },
  accessibility: {
    enabled: false,
  },
};
